module.exports = __webpack_public_path__ + "media/images/icons/icon-assessment-403136d15139e5ba0bf5a3c6cac1f30d.png";